
const partners = [
    {
        name: "National Weather Service",
        logo: "/partners/NWS.png",
        url: "https://www.weather.gov/",
    },
    {
        name: "National Mesonet",
        logo: "/partners/NNMN.png",
        url: "https://nationalmesonet.us/",
    },
    {
        name: "AASC",
        logo: "/partners/AASC.png",
        url: "https://stateclimate.org/",
    },
    { name: "WKU", logo: "/partners/WKU.jpg", url: "https://www.wku.edu/" },
    {
        name: "ARTP",
        logo: "/partners/ARTP.png",
        url: "https://www.wku.edu/artp/",
    },
    {
        name: "WRN",
        logo: "/partners/WRN.jpg",
        url: "https://www.weather.gov/contact/weatherreadynation",
    },
];



export default partners;